import {API_PATH} from "../../constants";
import {axiosRequest} from "../api";


export const VideoCallService = {
  connectToMeeting(data: any){ return axiosRequest('POST', API_PATH.VIDEO_CALL.MEETING, data) },
  connectToWaitingRoom(data: any){ return axiosRequest('POST', API_PATH.VIDEO_CALL.LOBBY, data) },
  getWaitingRoomList(data: any){ return axiosRequest('POST', API_PATH.VIDEO_CALL.LOBBY_LIST, data) },
}